import foodyAppIcon from "../assets/icons/foody-app-icon.svg";
import foodyMockup from "../assets/mockups/foody-mockup.svg";
import trainsEscapeIcon from "../assets/icons/trainsescape-app-icon.svg";
import trainsEscapeMockup from "../assets/mockups/trainsescape-mockup.svg";

const publishedApps = [
  {
    name: "foody: wellness",
    category: {
      en: "wellness",
      tr: "wellness",
    },
    description: {
      en: "snap a meal to see ingredients and calories, or scan barcodes for packaged foods",
      tr: "yemek fotoğrafı çekip içeriğini ve kalori bilgisini öğren, paketli gıdaları barkodla analiz et",
    },
    platform: "Android",
    tag: {
      en: "nutrition assistant",
      tr: "beslenme asistani",
    },
    detailPath: "/apps/foody",
    appStoreUrl: null,
    googlePlayUrl:
      "https://play.google.com/store/apps/details?id=com.wodaslabs.foody",
    logoPath: foodyAppIcon,
    mockupPath: foodyMockup,
  },
  {
    name: "trains escape",
    category: {
      en: "logic puzzle",
      tr: "mantık bulmacası",
    },
    description: {
      en: "tap trains to move them in locomotive direction and clear the board in the correct order",
      tr: "trenlere dokun, lokomotif yönüne göre çıkart ve tahtayı doğru sırayla temizle",
    },
    platform: "iOS + Android",
    tag: {
      en: "train puzzle",
      tr: "tren bulmacası",
    },
    detailPath: "/apps/trainsescape",
    appStoreUrl: "https://apps.apple.com/us/app/trains-escape/id6761054738",
    googlePlayUrl:
      "https://play.google.com/store/apps/details?id=com.wodaslabs.trainsescape",
    logoPath: trainsEscapeIcon,
    mockupPath: trainsEscapeMockup,
  },
];

const upcomingApps = [];

const stats = [
  {
    value: "12+",
    label: {
      en: "published apps",
      tr: "yayınlanan app",
    },
  },
  {
    value: "4.8",
    label: {
      en: "average rating",
      tr: "ortalama puan",
    },
  },
  {
    value: "1.2M",
    label: {
      en: "downloads",
      tr: "indirme",
    },
  },
];

export { publishedApps, upcomingApps, stats };
